import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-end mb-3" }
const _hoisted_2 = { class: "p-input-icon-right ml-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          modelValue: _ctx.state.keywords,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.keywords) = $event)),
          placeholder: _ctx.t('content.globalSearchInputPlaceholder'),
          style: {"width":"280px"},
          onKeyup: _ctx.onSearchKeywordClick
        }, null, 8, ["modelValue", "placeholder", "onKeyup"])
      ])
    ]),
    _createVNode(_component_DataTable, {
      selection: _ctx.state.selectedRow,
      "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedRow) = $event)),
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
      class: "p-datatable-sm",
      "column-resize-mode": "fit",
      "resizable-columns": true,
      "responsive-layout": "scroll",
      lazy: true,
      page: _ctx.state.lazyParams.page,
      rows: _ctx.state.lazyParams.rows,
      "total-records": _ctx.state.lazyParams.total,
      "selection-mode": "single",
      value: _ctx.state.researchGroup,
      "filter-display": "menu",
      paginator: true,
      "rows-per-page-options": [5, 10, 40],
      "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      "current-page-report-template": `{currentPage} ${_ctx.t(
      'content.globalPagingInformation.ofTitle'
    )} {totalPages} ${_ctx.t('content.globalPagingInformation.pagesTitle')}`,
      "data-key": "id",
      loading: _ctx.state.dataLoading,
      onRowSelect: _ctx.onRowSelect,
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPaginatorResearchGroupClick($event)))
    }, {
      paginatorend: _withCtx(() => []),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("content.noData")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("content.globalLoadingText")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          "selection-mode": "single",
          style: {"width":"40px"},
          exportable: false
        }),
        _createVNode(_component_Column, {
          field: "number",
          header: 
        _ctx.t('content.dataManagement.content.researchGroup.table.header.number')
      
        }, {
          editor: _withCtx(({ data, field }) => [
            _createVNode(_component_InputText, {
              modelValue: data[field],
              "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
              autofocus: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "name",
          header: 
        _ctx.t('content.dataManagement.content.researchGroup.table.header.name')
      
        }, {
          editor: _withCtx(({ data, field }) => [
            _createVNode(_component_InputText, {
              modelValue: data[field],
              "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
              autofocus: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["selection", "filters", "page", "rows", "total-records", "value", "current-page-report-template", "loading", "onRowSelect"])
  ], 64))
}